
import { Carousel } from "src/Components/Carousel/web"
import { formatPastEventsDate } from "src/functions/dateFormats";
import "./styles.less"

const country = {
    "1": {
        flag: "https://cdn4.fincaraiz.com.co/web/650cb8979c579_banderas-(1).png" //Uruguay
    },
    "2": {
        flag: "https://cdn4.fincaraiz.com.co/web/6514dd6903792_banderas-(2).png" //Paraguay
    },
    "3": {
        flag: "https://cdn4.fincaraiz.com.co/web/6514dcc28c91a_banderas-(4).png" //Argentina
    },
    "4": {
        flag: "https://cdn4.fincaraiz.com.co/web/6514dcc28d950_banderas-(3).png" //Chile
    },
    "5": {
        flag: "https://cdn4.fincaraiz.com.co/web/65146f135702d_banderas-bolivia.png" //Bolivia
    },
    "6": {
        flag: "https://cdn4.fincaraiz.com.co/web/66a2b00f0770b_banderas-04.png" //Colombia
    },
    "7": {
        flag: "https://cdn4.fincaraiz.com.co/web/66a2b02769cca_banderas-03.png" //Perú
    },
    "8": {
        flag: "https://cdn4.fincaraiz.com.co/web/66a2b00ecce4f_banderas-01.png" //Costa Rica
    },
    "9": {
        flag: "https://cdn4.fincaraiz.com.co/web/66a2b00f0ad6e_banderas-02.png" //Panamá
    }
}

export const EventCarousel = ({ data }) => {
    const CarouselItem = ({ data }) => {
        const currentCountry = country[data.countryId]
        const hourFormatted = formatPastEventsDate(data.startDate, data.endDate)

        const handleOpenLink = (e) => {
            if (data.linkGallery === "") e.preventDefault()
        }

        return (
            <a
                className={`carousel-item ${data.linkGallery !== "" ? "" : "cursor-default"}`} href={data.linkGallery !== "" ? data.linkGallery : "#"}
                onClick={(e) => handleOpenLink(e)}
                target="_blank"
            >
                <img src={data.image !== "" ? data.image : "https://cdn4.fincaraiz.com.co/web/651d9700db901_default-image.png"} className="carousel-item-image" />

                <span className="carousel-item-title">
                    {currentCountry && <img src={currentCountry?.flag} className="carousel-item-title-flag" />}
                    {data.name}
                </span>

                {data.linkGallery && <h1>¡VER EVENTO!</h1>}

                <div className="carousel-item-footer">
                    {data.location !== "" &&
                        <span>
                            <img src="https://cdn4.fincaraiz.com.co/web/650def27cf597_ubicacion@2x.png" />
                            {data.location}
                        </span>
                    }
                    <span>
                        <img src="https://cdn4.fincaraiz.com.co/web/650def27cf42a_calendario@2x.png" />
                        {hourFormatted}
                    </span>
                </div>
            </a>
        )
    };

    return (
        <div className="section-carousel">
            <h2 className="section-carousel-title">
                <span className="text-orange">ASÍ VIVIMOS</span> EVENTOS ANTERIORES
            </h2>

            <div className="container">
                <Carousel data={data} ItemComponent={CarouselItem} />
            </div>
        </div>
    )
}